import { CloseOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { Flex } from "antd";
import Text from "../text";
import React from "react";

const Styled = styled(Flex)`
  height: 2.3rem;
  padding: 0 1rem;
  border-radius: 1.5rem;
  background: ${(_) => _.theme.token.surface.primary};
`;

const Tag = ({ label = "", onClose = () => {} }) => {
  return (
    <Styled justify="center" align="center" gap={"1rem"}>
      <Text size={"1.1rem"} children={label} type="secondary" />
      <Text size={"1.1rem"} type="secondary">
        <CloseOutlined className="cursor-pointer" onClick={onClose} />
      </Text>
    </Styled>
  );
};

export default Tag;
